export default {
	"cancel.form.salutation.label": "Anrede",
	"cancel.form.salutation.mr": "Herr",
	"cancel.form.salutation.mrs": "Frau",
	"cancel.form.salutation.diverse": "Divers",
	"cancel.form.title.label": "Titel (optional)",
	"cancel.form.firstName.label": "Vorname",
	"cancel.form.firstName.placeholder": "Vorname",
	"cancel.form.lastName.label": "Nachname",
	"cancel.form.lastName.placeholder": "Nachname",
	"cancel.form.contractNumber.label": "Vertragsnummer",
	"cancel.form.contractNumber.placeholder": "FHXXXXXXX",
	"cancel.form.contractType.label": "Vertragsart, Bezeichnung",
	"cancel.form.contractType.placeholder": "z.B. Photovoltaikversicherung",
	"cancel.form.phone.label": "Telefonnummer (optional)",
	"cancel.form.phone.placeholder": "+49",
	"cancel.form.footnote": "* Pflichtfelder",
	"cancel.form.nav.next": "Weiter",
	"cancel.form.nav.back": "Zurück",
	"cancel.confirm.summary.title": "Zusammenfassung Ihrer Widerrufserklärung",
	"cancel.confirm.summary.name": "Name",
	"cancel.confirm.summary.email": "E-Mail-Adresse",
	"cancel.confirm.summary.phone": "Telefonnummer",
	"cancel.confirm.summary.unavailable": "k.A.",
	"cancel.confirm.nav.submit": "Widerruf bestätigen",
	"cancel.confirm.nav.back": "Zurück",
	"cancel.confirm.error": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut oder kontaktieren Sie unseren Support.",
	"cancel.success.message": "Ihre Widerrufserklärung ist bei uns eingegangen – Wir prüfen Ihre Anfrage und melden uns in Kürze bei Ihnen!{br}{br}Bei Fragen nutzen Sie unser Kontaktformular",
	"cancel.success.survey.title": "Wir bedauern Ihre Entscheidung - aber respektieren sie",
	"cancel.success.survey.body": "Wie war Ihre Erfahrung? Teilen Sie uns Ihre Meinung in einer kurzen Umfrage mit – Es dauert nur 5 Minuten.",
	"cancel.success.nav.survey": "An Umfrage teilnehmen",
	"cancel.success.nav.home": "Zur Startseite",
	"cancel.email.subject": "Ihr Widerruf ist bei uns eingegangen",
} as const;
